module.exports = __webpack_public_path__ + "static/img/keepstay-icon.cba8a298.png";